// The milestone ladder, shared by the worker (which announces crossings) and
// the client (progress meter, countdown mood). One table — if the two sides
// disagreed about where milestones sit, the celebration would fire at numbers
// the UI never promised.

/** Thresholds the Grand Tally celebrates crossing, ascending. */
export const MILESTONES: readonly number[] = [
  100, 500, 1_000, 5_000, 10_000, 50_000, 100_000, 500_000, 1_000_000, 5_000_000, 10_000_000,
];

/** The next milestone still ahead, or null once they're all behind us. */
export function nextMilestone(total: number): number | null {
  return MILESTONES.find((m) => m > total) ?? null;
}

/** The milestone (or 0) directly below `next` — the meter's starting line. */
export function prevMilestone(next: number): number {
  let prev = 0;
  for (const m of MILESTONES) {
    if (m >= next) break;
    prev = m;
  }
  return prev;
}

/**
 * Whether the tally is close enough to its next milestone for the site to
 * start warming up: fewer than 50 pops to go, or inside the last 5% of the
 * gap. Pure, so the hero can ask it on every sync without a network trip.
 */
export function isNearMilestone(total: number, next: number | null): boolean {
  if (next === null || total >= next) return false;
  const remaining = next - total;
  const span = next - prevMilestone(next);
  return remaining < 50 || remaining / span < 0.05;
}
